export default __webpack_public_path__ + "static/media/wedding-2.89603098.jpg";